import { eKeHoachMonHocNamHocHocKyActionsObj } from "../../action-types/ke-hoach/IKeHoachMonHocNamHocHocKy";
import { generateActions } from "../generateActions";

export const keHoachMonHocNamHocHocKyActions = {
    ...generateActions(eKeHoachMonHocNamHocHocKyActionsObj, "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY"),
    // ...generateActionForKey(eKeHoachMonHocNamHocHocKyActionsObj, "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY",
    //     "UPDATE_NHOMTUCHON_CONFIG_SUCCESS", () => { NotifyHelper.Success("Đã cập nhật") }
    // ),
    // ...generateActionForKey(eKeHoachMonHocNamHocHocKyActionsObj, "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY",
    //     "UPDATE_NHOMTUCHON_CONFIG_ERROR", (m) => { NotifyHelper.Error(m.data) }
    // ),
    // ...generateActionForKey(eKeHoachMonHocNamHocHocKyActionsObj, "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY",
    //     "UPDATE_SUCCESS", () => { NotifyHelper.Success("Đã cập nhật") }
    // ),
    // ...generateActionForKey(eKeHoachMonHocNamHocHocKyActionsObj, "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY",
    //     "UPDATE_ERROR", (m) => { NotifyHelper.Error(m.data) }
    // ),

}